<script>
    import { onMount } from "svelte";
    import * as api from "../stores/auth.store";
    import Header from "../components/Header.svelte";
    import { push } from "svelte-spa-router";

    onMount(() => {
        api.apiGetStatus();
    });
</script>

<Header />

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div class="menu-title">
    <p class="info-title">MENU</p>
</div>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div class="menu-wrap">
    <div class="menu-in">
        <div
            class="btn menu-btn"
            on:click={() => {
                push("/RcpMng");
            }}
        >
            <p>입고 관리</p>
        </div>
        <div
            class="btn menu-btn"
            on:click={() => {
                push("/RcpList");
            }}
        >
            <p>입고 내역</p>
        </div>
        <div
            class="btn menu-btn"
            on:click={() => {
                push("/DspMng");
            }}
        >
            <p>출고 관리</p>
        </div>
        <div
            class="btn menu-btn"
            on:click={() => {
                push("/DspList");
            }}
        >
            <p>출고 내역</p>
        </div>
        <div
            class="btn menu-btn"
            on:click={() => {
                push("/ShipMng");
            }}
        >
            <p>출하 관리</p>
        </div>
    </div>
</div>
